<template>
  <div v-if="fallback">
    <select-input
      label
      v-model="config.fallbackVoice"
      use="value"
      display="display"
      disable-sort
      :options="voiceOptions"
    >Fallback Voice (when no specific Character with a set Voice is the speaker (e.g. non-bubble decisions))</select-input>
    <number-input
      v-model="config.fallbackGoogleTtsAudioConfig.speakingRate"
      label
      style="margin-left: 32px;"
    >Speaking Rate (default: 1) (range: [0.25, 4.0])</number-input>
    <number-input
      v-model="config.fallbackGoogleTtsAudioConfig.pitch"
      label
      style="margin-left: 32px;"
    >Pitch (default: 0) (range: [-20.0, 20.0])</number-input>
    <number-input
      v-model="config.fallbackGoogleTtsAudioConfig.volumeGainDb"
      label
      style="margin-left: 32px;"
    >Volume Gain (dB) (default: 0) (range: [-96.0, 16.0])</number-input>
  </div>
  <div v-else>
    <div v-if="character" style="display: flex; flex-flow: row wrap;">
      <button
        v-if="character"
        class="btn"
        @click.prevent="matchCharacterVoice"
        style="
          padding: 0 5px;
          margin-right: 16px;
        "
      >
        Match Character Voice
      </button>
      <a :href="`/blade/characters/${character}/edit`" target="_blank">View character.</a>
    </div>
    <select-input
      label
      v-model="config.voice"
      use="value"
      display="display"
      disable-sort
      :options="voiceOptions"
    >Voice</select-input>
    <number-input
      v-model="config.googleTtsAudioConfig.speakingRate"
      label
    >Speaking Rate (default: 1) (range: [0.25, 4.0])</number-input>
    <number-input
      v-model="config.googleTtsAudioConfig.pitch"
      label
    >Pitch (default: 0) (range: [-20.0, 20.0])</number-input>
    <number-input
      v-model="config.googleTtsAudioConfig.volumeGainDb"
      label
    >Volume Gain (dB) (default: 0) (range: [-96.0, 16.0])</number-input>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import NumberInput from '../../../ui/inputs/NumberInput';
import SelectInput from '../../../ui/inputs/SelectInput';
import Voices from '../../../../utils/google-tts-voices';

export default {
  components: {
    NumberInput,
    SelectInput,
  },
  props: {
    config: { type: Object },
    fallback: { type: Boolean },
    character: { type: String }, // optional
  },
  data() {
    return {
      voiceOptions: Voices.map(voice => ({
        value: voice.name,
        display: voice.display,
      }))
    };
  },
  methods: {
    ...mapActions([
      'getCharacterVoice',
      'flashDanger',
    ]),
    async matchCharacterVoice() {
      try {
        const ch = await this.getCharacterVoice({ characterId: this.character });
        if (ch) {
          console.log(ch);
          if (ch.voice) this.config.voice = ch.voice;
          if (ch.googleTtsAudioConfig) {
            this.config.googleTtsAudioConfig.speakingRate = ch.googleTtsAudioConfig.speakingRate;
            this.config.googleTtsAudioConfig.pitch = ch.googleTtsAudioConfig.pitch;
            this.config.googleTtsAudioConfig.volumeGainDb = ch.googleTtsAudioConfig.volumeGainDb;
          }
        }
      } catch (err) {
        console.log(err);
        this.flashDanger({ message: 'Error fetching character voice. See browser console for details.' });
      }
    }
  },
  created() {
    if (this.fallback) {
      console.log(this.config.fallbackGoogleTtsAudioConfig);
      if (this.config.fallbackGoogleTtsAudioConfig == null) {
        this.config.fallbackGoogleTtsAudioConfig = {
          speakingRate: 1,
          pitch: 0,
          volumeGainDb: 0,
        };
        console.log(this.config.fallbackGoogleTtsAudioConfig);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.config.googleTtsAudioConfig == null) {
        this.config.googleTtsAudioConfig = {
          speakingRate: 1,
          pitch: 0,
          volumeGainDb: 0,
        };
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/VoiceConfigEditor.vue